module.exports = __webpack_public_path__ + "static/img/bg.2602410.png";


//////////////////
// WEBPACK FOOTER
// ./examples/assets/bg.png
// module id = zoaW
// module chunks = 1